import { ContentMetadata } from '@candu-ai/content/types';
import { CONTENT_PUBLISHED_STATES } from 'commons/models';

export const canPublishChanges = (
  { id, lastModifiedAt, lastPublishedAt }: any,
  tutorialActions: any,
) => {
  const relevantActions = tutorialActions.filter((resource: any) => resource?.id === id);

  if (relevantActions.length < 1) {
    return { canPublish: lastModifiedAt !== lastPublishedAt, lastPublishedAt };
  }
  // At this point, we're certain that the last action has a greater timestamp
  // that `lastPublishedAt` so there is no point in checking.
  // just check if there was a publish aciton after that.
  return {
    canPublish: true,
    lastPublishedAt: relevantActions[relevantActions.length - 1].timestamp,
    lastModifiedAt,
  };
};

export const documentHasCheckList = (tutorialDocument: any) => {
  const nodes = tutorialDocument?.document?.nodes;
  return !!nodes && Object.values(nodes).some((node: any) => node.type.startsWith('CheckList'));
};

export const editorSegmentPath = (segmentId: any) => {
  // can only be called in the context of the editor page
  return window.location.pathname.replace(/\/content\/.*/g, `/content/${segmentId}`);
};

export const getPublishedState = (content: ContentMetadata) => {
  if (content.archivedAt) {
    return CONTENT_PUBLISHED_STATES.ARCHIVED;
  }
  if (content.visibilityState === 'Off') {
    return CONTENT_PUBLISHED_STATES.DRAFT;
  }

  if (content.lastPublishedAt && content.lastModifiedAt) {
    return new Date(content.lastPublishedAt) >= new Date(content.lastModifiedAt)
      ? CONTENT_PUBLISHED_STATES.PUBLISHED
      : CONTENT_PUBLISHED_STATES.UNSYNCED;
  }
  if (content.lastPublishedAt) {
    return CONTENT_PUBLISHED_STATES.PUBLISHED;
  }

  return CONTENT_PUBLISHED_STATES.DRAFT;
};
